import { z } from "zod";

export const synapticRoleSchema = z.enum([
  "administrator",
  "customer",
  "developer",
  "email_account",
  "editor",
  "member",
  "moderator",
  "super_admin",
  "tenant_admin",
]);

export const synapticTenantIdSchema = z.union([
  z.literal("default-tenant-id"),
  z.uuid(),
]);

export const synapticJwtClaimsSchema = z.object({
  id: z.string().min(1).optional(),
  user_id: z.string().min(1).optional(),
  sub: z.string().min(1).optional(),
  email: z.string().email(),
  tenant_id: synapticTenantIdSchema.optional(),
  roles: z.array(z.string().min(1)),
  iat: z.number().int().nonnegative().optional(),
  exp: z.number().int().nonnegative().optional(),
  name: z.string().min(1).optional(),
  picture: z.string().url().optional(),
  avatar_url: z.string().url().optional(),
}).passthrough().refine(
  (claims) => Boolean(claims.id || claims.user_id || claims.sub),
  {
    message: "The JWT must include id, user_id, or sub",
    path: ["id"],
  },
);

export type SynapticRole = z.infer<typeof synapticRoleSchema>;

export type SynapticJwtClaims = z.infer<typeof synapticJwtClaimsSchema>;
